<template>
    <div class="container">
        <div class="uniform-modal-body">

            <div class="d-flex col-md-12 justify-content-center">
                <CorporateDataTable
                    id="cifras-table"
                    ref="cifrasTable"
                    :headers="tableHeaders"
                    :items="tableData"
                    :exportable="false"
                    :showFilter="false"
                    :showPagination="false"
                    :itemsPerPage="20"
                    :theme="'primary'"
                    :loading="loading"
                    class="w-100"
                >
                    <template #column-x="{ item }">
                        <span
                            v-if="item.x && item.x !== ''"
                            class="font-weight-bold"
                        >
                            {{ item.x }}
                        </span>

                        <span
                            v-else
                            class="text-muted"
                        >
                            -
                        </span>
                    </template>

                    <template #column-descripcion="{ item }">
                        <span
                            v-if="item.descripcion === 'Score'"
                            class="font-weight-bold text-primary"
                        >
                            {{ item.descripcion }}
                        </span>

                        <span
                            v-else-if="item.descripcion === 'Calificación'"
                            class="font-weight-bold text-success"
                        >
                            {{ item.descripcion }}
                        </span>

                        <span v-else>
                            {{ item.descripcion }}
                        </span>
                    </template>

                    <template #column-cifra="{ item }">
                        <span
                            v-if="item.cifra && item.cifra !== '-'"
                            class="text-right font-weight-bold"
                        >
                            {{ item.cifra }}
                        </span>

                        <span
                            v-else
                            class="text-muted"
                        >
                            -
                        </span>
                    </template>

                    <template #column-indice="{ item }">
                        <span
                            v-if="item.indice && item.indice !== '-'"
                            class="text-primary font-weight-bold"
                        >
                            {{ item.indice }}
                        </span>

                        <span
                            v-else-if="item.indice === 'Sin calificar'"
                            class="text-warning"
                        >
                            {{ item.indice }}
                        </span>

                        <span
                            v-else
                            class="text-muted"
                        >
                            -
                        </span>
                    </template>
                </CorporateDataTable>
            </div>
        </div>
    </div>
</template>

<script>
import CorporateDataTable from '../../utils/CorporateDataTable.vue';
import Calificacion from '../../../services/Calificacion';
import Score from '../../../services/Score';

export default {
    name: 'Cifras',

    components: {
        CorporateDataTable
    },

    props: {
        infoFinanciera: {
            type: Object,
            default: () => ({})
        },

        infoConstante: {
            type: Object,
            default: () => ({})
        },

        saveScore: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            qlity: '',
            rslCalificacion: '',

            constX1: null,
            constX2: null,
            constX3: null,
            constX4: null,

            loading: false,

            tableHeaders: [
                {
                    text: 'X',
                    value: 'x',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    text: 'Descripción',
                    value: 'descripcion',
                    sortable: false
                },
                {
                    text: 'Cifra',
                    value: 'cifra',
                    sortable: false,
                    class: 'text-right'
                },
                {
                    text: 'Índice',
                    value: 'indice',
                    sortable: false,
                    class: 'text-center'
                }
            ],

            tableData: []
        };
    },

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: 'Score',
                    save: 'Guardar',
                    close: 'Cerrar',
                    editar: 'Editar',
                    cifras: 'Cifras'
                };
            } else {
                return {
                    title: 'Score',
                    save: 'Save',
                    close: 'Close',
                    editar: 'Edit',
                    cifras: 'Figures'
                };
            }
        }
    },

    methods: {

        // ---------------------------------------------------------
        // X1
        // ---------------------------------------------------------
        calcActCorMenosPasCor(activo_corriente, pasivo_corriente) {
            const resultado =
                activo_corriente - pasivo_corriente;

            return this.formatNumber(resultado);
        },

        const_1(
            activo_corriente,
            pasivo_corriente,
            total_activo
        ) {
            let resta =
                activo_corriente - pasivo_corriente;

            let result =
                (resta / total_activo) *
                this.infoConstante.constante_1;

            this.constX1 = result.toFixed(2);

            return result?.toFixed(2);
        },

        // ---------------------------------------------------------
        // X2
        // ---------------------------------------------------------
        const_2(
            utilidad_acumulada,
            total_activo
        ) {
            let ope =
                utilidad_acumulada / total_activo;

            let result =
                ope * this.infoConstante.constante_2;

            this.constX2 = result.toFixed(2);

            return result?.toFixed(2);
        },

        // ---------------------------------------------------------
        // X3
        // ---------------------------------------------------------
        const_3(
            ebit,
            total_activo
        ) {
            let ope =
                ebit / total_activo;

            let result =
                ope * this.infoConstante.constante_3;

            this.constX3 = result.toFixed(2);

            return result?.toFixed(2);
        },

        // ---------------------------------------------------------
        // X4
        // ---------------------------------------------------------
        const_4(
            total_patrimonio,
            total_pasivo
        ) {
            let ope =
                total_patrimonio / total_pasivo;

            let result =
                ope * this.infoConstante.constante_4;

            this.constX4 = result.toFixed(2);

            return result?.toFixed(2);
        },

        // ---------------------------------------------------------
        // SCORE
        // ---------------------------------------------------------
        const_5(
            activo_corriente,
            pasivo_corriente,
            total_activo,
            utilidad_acumulada,
            total_patrimonio,
            total_pasivo,
            ebit
        ) {
            let resta =
                activo_corriente - pasivo_corriente;

            let constX1 =
                (resta / total_activo) *
                this.infoConstante.constante_1;

            let constX2 =
                (utilidad_acumulada / total_activo) *
                this.infoConstante.constante_2;

            let constX3 =
                (ebit / total_activo) *
                this.infoConstante.constante_3;

            let constX4 =
                (total_patrimonio / total_pasivo) *
                this.infoConstante.constante_4;

            let result =
                constX1 +
                constX2 +
                constX3 +
                constX4 +
                parseFloat(this.infoConstante.score, 10);

            let calificacion =
                result.toFixed(2);

            this.qlity = calificacion;

            return calificacion;
        },

        // ---------------------------------------------------------
        // CONSULTAR CALIFICACIÓN
        // ---------------------------------------------------------
        async calificacion() {

            if (
                !this.infoFinanciera?.vigencia ||
                !this.qlity
            ) {
                return null;
            }

            try {

                const res =
                    await Calificacion.calificacionByVigenciaAndCalificacion(
                        this.infoFinanciera.vigencia,
                        this.qlity
                    );

                const lista =
                    res.data.calificaByVigCalifi || [];

                if (lista.length > 0) {

                    this.rslCalificacion = lista[0].calificacion;

                    return this.rslCalificacion;
                }

                this.rslCalificacion = '';

                console.log(
                    'No se encontró calificación'
                );

                return null;

            } catch (err) {

                console.log(
                    'Error consultando calificación:',
                    err
                );

                this.rslCalificacion = '';

                return null;
            }
        },

        // ---------------------------------------------------------
        // FORMATEAR NÚMEROS
        // ---------------------------------------------------------
        formatNumber(value) {

            if (!value && value !== 0) {
                return '-';
            }

            return new Intl.NumberFormat('es-CO', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 3
            }).format(value);
        },

        // ---------------------------------------------------------
        // CERRAR
        // ---------------------------------------------------------
        cerrarCifras() {
            this.$emit('cerrar-cifras', false);
        },

        // ---------------------------------------------------------
        // ARMAR TABLA
        // ---------------------------------------------------------
        buildTableData() {

            const activoCorriente =
                this.infoFinanciera?.activo_corriente || 0;

            const pasivoCorriente =
                this.infoFinanciera?.pasivo_corriente || 0;

            const totalActivo =
                this.infoFinanciera?.total_activo || 0;

            const utilidadAcumulada =
                this.infoFinanciera?.utilidad_acumulada || 0;

            const totalPatrimonio =
                this.infoFinanciera?.total_patrimonio || 0;

            const totalPasivo =
                this.infoFinanciera?.total_pasivo || 0;

            const ebit =
                this.infoFinanciera?.ebit || 0;

            // Calcular X1
            const x1 =
                this.const_1(
                    activoCorriente,
                    pasivoCorriente,
                    totalActivo
                );

            // Calcular X2
            const x2 =
                this.const_2(
                    utilidadAcumulada,
                    totalActivo
                );

            // Calcular X3
            const x3 =
                this.const_3(
                    ebit,
                    totalActivo
                );

            // Calcular X4
            const x4 =
                this.const_4(
                    totalPatrimonio,
                    totalPasivo
                );

            // Calcular SCORE
            const score =
                this.const_5(
                    activoCorriente,
                    pasivoCorriente,
                    totalActivo,
                    utilidadAcumulada,
                    totalPatrimonio,
                    totalPasivo,
                    ebit
                );

            /*
             * IMPORTANTE:
             *
             * Aquí YA NO llamamos:
             *
             * this.calificacion()
             *
             * porque esa función es asíncrona.
             *
             * La calificación se consulta antes de llamar
             * nuevamente a buildTableData().
             */

            this.tableData = [

                {
                    x: 'X1',
                    descripcion:
                        'Activo corriente - Pasivo corriente',
                    cifra:
                        this.calcActCorMenosPasCor(
                            activoCorriente,
                            pasivoCorriente
                        ),
                    indice: x1
                },

                {
                    x: '',
                    descripcion: 'Total activo',
                    cifra:
                        this.formatNumber(totalActivo),
                    indice: '-'
                },

                {
                    x: 'X2',
                    descripcion: 'Utilidad acumulada',
                    cifra:
                        this.formatNumber(
                            utilidadAcumulada
                        ),
                    indice: x2
                },

                {
                    x: '',
                    descripcion: 'Total activo',
                    cifra:
                        this.formatNumber(totalActivo),
                    indice: '-'
                },

                {
                    x: 'X3',
                    descripcion: 'EBIT',
                    cifra:
                        this.formatNumber(ebit),
                    indice: x3
                },

                {
                    x: '',
                    descripcion: 'Total activo',
                    cifra:
                        this.formatNumber(totalActivo),
                    indice: '-'
                },

                {
                    x: 'X4',
                    descripcion: 'Patrimonio',
                    cifra:
                        this.formatNumber(
                            totalPatrimonio
                        ),
                    indice: x4
                },

                {
                    x: '',
                    descripcion: 'Pasivo',
                    cifra:
                        this.formatNumber(
                            totalPasivo
                        ),
                    indice: '-'
                },

                {
                    x: '',
                    descripcion: 'Score',
                    cifra: '-',
                    indice: score
                },

                {
                    x: '',
                    descripcion: 'Calificación',
                    cifra: '-',
                    indice:
                        this.rslCalificacion ||
                        'Sin calificar'
                }
            ];
        },

        // ---------------------------------------------------------
        // GUARDAR SCORE
        // ---------------------------------------------------------
        async saveScoreData() {

            if (!this.infoFinanciera?.vigencia) {
                return;
            }

            try {

                // =================================================
                // 1. GUARDAR CIFRAS
                // =================================================

                const info = {
                    vigencia:
                        this.infoFinanciera.vigencia,

                    activoCorriente_PasivoCorriente:
                        this.infoFinanciera.activo_corriente -
                        this.infoFinanciera.pasivo_corriente,

                    total_activo:
                        this.infoFinanciera.total_activo,

                    utilidad_acumulada:
                        this.infoFinanciera.utilidad_acumulada,

                    ebit:
                        this.infoFinanciera.ebit,

                    patrimonio:
                        this.infoFinanciera.total_patrimonio,

                    pasivo:
                        this.infoFinanciera.total_pasivo
                };

                // console.log(
                //     'DATA SCORE CIFRAS:',
                //     info
                // );

                const resCifras =
                    await Score.createScoreCifras(info);

                if (resCifras.status == 201) {

                    this.$toast.success(
                        resCifras.data.message
                    );
                }


                // =================================================
                // 2. ASEGURAR QUE TENEMOS EL SCORE
                // =================================================

                if (!this.qlity) {

                    this.buildTableData();
                }


                // =================================================
                // 3. CONSULTAR CALIFICACIÓN
                // =================================================

                if (!this.rslCalificacion) {

                    await this.calificacion();
                }


                // =================================================
                // 4. ACTUALIZAR TABLA CON LA CALIFICACIÓN
                // =================================================

                this.buildTableData();


                // =================================================
                // 5. VERIFICAR CALIFICACIÓN
                // =================================================

                // console.log(
                //     'Score calculado:',
                //     this.qlity
                // );

                console.log(
                    'Calificación antes de guardar:',
                    this.rslCalificacion
                );


                // =================================================
                // 6. CONSTRUIR DATA PARA SCORE X
                // =================================================

                const data = {

                    vigencia:
                        this.infoFinanciera.vigencia,

                    x1:
                        this.constX1,

                    x2:
                        this.constX2,

                    x3:
                        this.constX3,

                    x4:
                        this.constX4,

                    score:
                        this.qlity,

                    calificacion:
                        this.rslCalificacion
                };


                // console.log(
                //     'DATA CREATE SCORE X:',
                //     data
                // );


                // =================================================
                // 7. GUARDAR SCORE X
                // =================================================

                const resScore =
                    await Score.createScoreX(data);

                if (resScore.status == 201) {

                    this.$toast.success(
                        resScore.data.message
                    );
                }

            } catch (err) {

                console.log(
                    'Error guardando Score:',
                    err
                );

                this.$toast.error(
                    'Problema al guardar la información'
                );
            }
        }
    },

    // =============================================================
    // MOUNTED
    // =============================================================

    async mounted() {

        /*
         * Primero calculamos X1, X2, X3, X4 y Score.
         */
        this.buildTableData();


        /*
         * Luego consultamos la calificación.
         *
         * IMPORTANTE:
         * await espera a que el backend responda.
         */
        await this.calificacion();


        /*
         * Volvemos a construir la tabla para mostrar
         * la calificación obtenida.
         */
        this.buildTableData();


        /*
         * Si el padre indicó que debe guardar,
         * guardamos solamente después de tener
         * la calificación.
         */
        if (this.saveScore) {

            await this.saveScoreData();
        }
    },

    // =============================================================
    // WATCH
    // =============================================================

    watch: {

        infoFinanciera: {

            deep: true,

            handler() {

                /*
                 * Cuando cambian los datos financieros,
                 * volvemos a calcular X1-X4 y Score.
                 */
                this.rslCalificacion = '';

                this.buildTableData();

                /*
                 * Consultamos nuevamente la calificación
                 * correspondiente al nuevo Score.
                 */
                this.calificacion()
                    .then(() => {
                        this.buildTableData();
                    });
            }
        },

        infoConstante: {

            deep: true,

            handler() {

                /*
                 * Las constantes pueden cambiar el Score,
                 * por eso también debemos limpiar la
                 * calificación anterior.
                 */
                this.rslCalificacion = '';

                this.buildTableData();

                this.calificacion()
                    .then(() => {
                        this.buildTableData();
                    });
            }
        }
    }
};
</script>

<style scoped>
.uniform-modal-body {
    padding: 0.5rem 0;
}

.password-policy-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0;
}

.reset-dialog-actions {
    gap: 10px;
}

.reset-btn-secondary {
    background-color: #6c757d;
    border: 1px solid #6c757d;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
    color: white;
}

.reset-btn-primary {
    background-color: #007bff;
    border: 1px solid #007bff;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: white;
}

/* Estilos para el CorporateDataTable */
/*
::v-deep .corporate-data-table .table thead th {
    background-color: #2e507a !important;
    color: white !important;
    font-weight: 600;
    text-align: center;
    padding: 0.75rem;
    border-color: #1a3a5c;
}

::v-deep .corporate-data-table .table tbody td {
    padding: 0.65rem 0.75rem;
    vertical-align: middle;
}

::v-deep .corporate-data-table .table tbody tr:hover {
    background-color: #f8f9fa !important;
}

::v-deep .corporate-data-table .text-right {
    text-align: right !important;
}

::v-deep .corporate-data-table .text-center {
    text-align: center !important;
}

::v-deep .corporate-data-table .font-weight-bold {
    font-weight: 700 !important;
}

::v-deep .corporate-data-table .text-primary {
    color: #007bff !important;
}

::v-deep .corporate-data-table .text-success {
    color: #28a745 !important;
}

::v-deep .corporate-data-table .text-warning {
    color: #ffc107 !important;
}

::v-deep .corporate-data-table .text-muted {
    color: #6c757d !important;
}

@media (max-width: 768px) {

    .reset-dialog-actions {
        flex-direction: column;
    }

    .reset-dialog-actions .b-button {
        width: 100%;
        margin: 0.25rem 0 !important;
    }

    ::v-deep .corporate-data-table .table {
        font-size: 0.8rem;
    }

    ::v-deep .corporate-data-table .table td,
    ::v-deep .corporate-data-table .table th {
        padding: 0.4rem 0.5rem;
    }
}
    */
</style>